import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';
import { CacheRequestHeaders } from './cache.interface';
import { genRequestKey } from './utils';

@Injectable({
  providedIn: 'root',
})
export class MergeRequestsInterceptor implements HttpInterceptor {
  private readonly parallelRequests = new Map<
    string,
    Observable<HttpEvent<unknown>>
  >();

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const reqKey = `${genRequestKey(req)}${req.headers.get(CacheRequestHeaders.NAME) ?? ''}`;
    const parallelRequest = this.parallelRequests.get(reqKey);

    if (parallelRequest) {
      return parallelRequest;
    }

    const shared = next.handle(req).pipe(
      finalize(() => this.parallelRequests.delete(reqKey)),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
    this.parallelRequests.set(reqKey, shared);

    return shared;
  }
}
